import React from "react";
import { X, Bot, GripVertical, Trash2 } from "lucide-react";

const ICON_BTN = "p-1.5 rounded-[2px] text-[#D7DEE7] hover:text-white hover:bg-white/10 transition-colors";
const stop = (e) => e.stopPropagation();

export const ChatHeader = ({ onDragStart, onClear, onClose }) => (
  <div
    data-testid="chat-drag-handle"
    onPointerDown={onDragStart}
    style={{ touchAction: "none" }}
    className="relative px-4 py-3.5 bg-[#04162E] cursor-grab active:cursor-grabbing select-none"
  >
    <div className="absolute inset-0 blueprint-grid opacity-70" />
    <div className="relative flex items-center justify-between">
      <div className="flex items-center gap-3">
        <div className="relative grid place-items-center h-9 w-9 rounded-[3px] bg-white/10 border border-white/15">
          <Bot className="h-5 w-5 text-white" />
          <span className="absolute -bottom-0.5 -right-0.5 h-3 w-3 rounded-full bg-[#0E8A57] border-2 border-[#04162E]" />
        </div>
        <div className="leading-tight">
          <div className="font-display text-base font-bold text-white">Emmy · AI Support</div>
          <div className="font-body text-[11px] text-[#8FA0B3]">Online · Powered by AI</div>
        </div>
      </div>
      <div className="flex items-center gap-1">
        <GripVertical className="h-4 w-4 text-[#8FA0B3]" title="Drag to move" />
        <button
          data-testid="chat-clear"
          onClick={onClear}
          onPointerDown={stop}
          className={ICON_BTN}
          aria-label="Clear conversation"
          title="Clear conversation"
        >
          <Trash2 className="h-4 w-4" />
        </button>
        <button data-testid="chat-close" onClick={onClose} onPointerDown={stop} className={ICON_BTN} aria-label="Close chat">
          <X className="h-5 w-5" />
        </button>
      </div>
    </div>
  </div>
);
